import { ReactNode } from 'react'
import { Table, Thead } from './styles'

type TableProductDetailsPredictionProps = {
  children: ReactNode
  headers: string[]
  size?: string
}

export function TableProductDetailsPrediction({
  headers,
  children,
  size,
}: TableProductDetailsPredictionProps) {
  return (
    <Table size={size} border={0} cellPadding={0}>
      <Thead>
        <tr>
          {headers.map(titulo => (
            <th key={titulo}>{titulo}</th>
          ))}
        </tr>
      </Thead>
      <tbody>{children}</tbody>
    </Table>
  )
}
